import {
  ApolloClient,
  gql,
  MutationOptions,
  TypedDocumentNode,
} from '@apollo/client'
import { cartDetailsFragment, cartFragment } from '@emico-hooks/cart-fragment'
import { getCustomerTokenHeaderObject } from '@emico-hooks/login-token'

import {
  MergeCartsMutation,
  MergeCartsMutationVariables,
} from '@emico-hooks/cart-merge/src/mergeCarts.generated'

const mutation = gql`
  mutation MergeCarts($source: String!, $destination: String!) {
    mergeCarts(source_cart_id: $source, destination_cart_id: $destination) {
      ...CartFragment
      ...CartDetailsFragment
    }
  }
  ${cartFragment}
  ${cartDetailsFragment}
` as TypedDocumentNode<MergeCartsMutation, MergeCartsMutationVariables>

export type MergeCartOptions = Omit<
  MutationOptions<MergeCartsMutation, MergeCartsMutationVariables>,
  'mutation'
>

export const mergeCarts = (
  client: ApolloClient<unknown>,
  token: string | undefined,
  source: string,
  destination: string,
  options?: MergeCartOptions,
) =>
  client.mutate({
    mutation,
    variables: {
      source,
      destination,
    },
    context: getCustomerTokenHeaderObject(token),
    ...options,
    update(cache,data){
      const mergedCart = data.data?.mergeCarts
      cache.modify({
        fields: {
          cart(currentCart){
            const cart = cache.writeFragment({
              data: {...currentCart, ...mergedCart},
              fragment: gql`
              fragment CartDetailsFragment on Cart {
                email
              }
              `
            })
            return cart
          }
        }
      });
    }
  })
